// src/components/MobileBottomNav.js
import React, { useContext, useState } from "react";
import { BottomNavigation, BottomNavigationAction, Paper, useMediaQuery } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import GroupIcon from '@mui/icons-material/Group';
import PersonIcon from "@mui/icons-material/Person";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import SavingsOutlinedIcon from "@mui/icons-material/SavingsOutlined";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../context/AuthContext";

export default function MobileBottomNav() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useContext(AuthContext);

  const match = location.pathname.match(/^\/([a-z]{2}(?:-[a-z]{2})?)\b/);
  const country = match ? match[1] : "el";

  // ΜΟΝΟ τα πιο βασικά routes!
  const items = user ? [
    { label: t("dashboard"), icon: <HomeIcon />, path: `/${country}/client/dashboard` },
    { label: t("budget_recipes.mobile_label", "Budget"), icon: <SavingsOutlinedIcon />, path: `/${country}/budget-recipes` },
    { label: t("shopping_list"), icon: <ShoppingCartIcon />, path: `/${country}/client/shopping/list` },
    { label: t("meal_plan"), icon: <RestaurantIcon />, path: `/${country}/client/meal/plan` },
    { label: t("inventory"), icon: <Inventory2Icon />, path: `/${country}/client/inventory/check` },
    { label: t("account"), icon: <GroupIcon />, path: `/${country}/client/household/profile` },
  ] : [
    { label: t("home"), icon: <HomeIcon />, path: `/${country}/` },
    { label: t("budget_recipes.mobile_label", "Budget"), icon: <SavingsOutlinedIcon />, path: `/${country}/budget-recipes` },
    { label: t("login"), icon: <PersonIcon />, path: `/${country}/login` }
  ];

  const activeIndex = items.findIndex(item =>
    location.pathname.startsWith(item.path.replace(/\/$/, ""))
  );
  const [value, setValue] = useState(activeIndex === -1 ? 0 : activeIndex);

  // Mobile only!
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  if (!isMobile) return null;

  return (
    <Paper 
      sx={{
        display: { xs: "flex", md: "none" },
        position: "fixed",
        zIndex: 1100,
        bottom: 0, left: 0, right: 0,
        borderTop: "1.5px solid #ecf4f2",
        bgcolor: "background.paper",
        boxShadow: "0 -2px 18px #49bc9022",
      }} 
      elevation={8}
    >
      <BottomNavigation
        showLabels
        value={value}
        onChange={(_, newValue) => {
          setValue(newValue);
          navigate(items[newValue].path);
        }}
        sx={{
          width: "100%",
          "& .Mui-selected": { color: "primary.main", fontWeight: 800 },
          "& .MuiBottomNavigationAction-label": { fontSize: 13, fontWeight: 700 }
        }}
      >
        {items.map((item, i) => (
          <BottomNavigationAction
            key={i}
            label={item.label}
            icon={item.icon}
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
}
